import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  // 'staff' in the allow-list also covers any custom internal role (accountant,
  // collections officer, etc.) — anything that isn't the reserved 'admin'/'tenant'
  // roles — mirroring the same rule the backend's authorize() middleware applies.
  const isCustomStaffRole = allowedRoles?.includes('staff') && user.role !== 'admin' && user.role !== 'tenant';
  if (allowedRoles && !allowedRoles.includes(user.role) && !isCustomStaffRole) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;


